import { createColDefs } from '@fortem-monorepo/react-ag'

export const createFundsColDefs = (canEdit: boolean) => {
  return createColDefs([
    {
      field: 'fund_id',
      hide: false,
      width: 90,
    },
    {
      field: 'currency_id',
      hide: true,
    },
    {
      field: 'fund_name',
      headerName: 'Name',
      width: 115,
    },
    {
      field: 'currency',
      headerName: 'Currency',
      width: 110,
    },
    {
      field: 'agent_name',
      headerName: 'Agent',
      width: 110,
      editable: canEdit,
    },
    {
      field: 'fund_number',
      headerName: '#Number',
      width: 110,
      editable: canEdit,
    },
    {
      field: 'account_number',
      headerName: '#Account',
      width: 110,
      editable: canEdit,
    },
    {
      field: 'active',
      headerName: 'Active',
      width: 110,
      editable: canEdit,
    },
    {
      field: 'fund_long_name',
      headerName: 'Long Name',
      width: 300,
      editable: canEdit,
    },
    {
      field: 'platform_name',
      headerName: 'Platform',
      width: 250,
      editable: canEdit,
    },
  ])
}

export const shareclassColDefs = createColDefs([
  {
    field: 'instrument_id',
    hide: true,
    width: 125,
  },
  {
    field: 'shareclass_id',
    hide: true,
    width: 125,
  },
  {
    field: 'currency_id',
    hide: true,
  },
  {
    field: 'fund_id',
    hide: true,
  },
  {
    field: 'fund_name',
    headerName: 'Fund',
    rowGroup: true,
    hide: true,
  },
  {
    field: 'isin',
    headerName: 'Isin',
    width: 115,
  },
  {
    field: 'shareclass_code',
    headerName: 'Code',
    width: 150,
  },
  {
    field: 'shareclass_sleeve',
    headerName: '#Sleeve',
    width: 100,
  },
  {
    field: 'share_class_name',
    headerName: 'Name',
    width: 175,
  },
  {
    field: 'base_currency',
    headerName: 'Fund Ccy',
    width: 105,
  },
  {
    field: 'hedge_currency',
    headerName: 'Hedge Ccy',
    width: 105,
  },
  {
    field: 'launched_date',
    headerName: 'Launch',
    width: 100,
  },
  {
    field: 'redeemed_date',
    headerName: 'Redeem',
    width: 100,
  },
  {
    field: 'is_main',
    headerName: 'Main',
    width: 115,
  },
  {
    field: 'is_distribution',
    headerName: 'Distributed',
    width: 115,
  },
  {
    field: 'is_hedged',
    headerName: 'Hedged',
    width: 110,
  },
])

export const bucketsColDefs = createColDefs([
  {
    field: 'bucket_id',
    headerName: 'id',
    width: 100,
    hide: true,
  },
  {
    field: 'bucket_type',
    headerName: 'Type',
    width: 150,
    rowGroup: true,
    hide: true,
  },
  {
    field: 'bucket_name',
    headerName: 'Name',
    width: 150,
  },
])
